<template>
  <b-container>
    <b-embed
      v-if="accessRecurrence"
      :src="dashboardUrl"
      type="iframe"
      aspect="16by9"
      allowfullscreen
    />
    <noPermission v-else />
  </b-container>
</template>
<script>
import {
  BContainer,
  BEmbed,
} from 'bootstrap-vue'
import noPermission from '@/views/error/NoPermission.vue'
import { getMerchantData } from '@/utils/get-merchant-data'

const jwt = require('jsonwebtoken')

export default {
  components: {
    BContainer,
    BEmbed,
    noPermission,
  },
  data() {
    return {
      accessRecurrence: false,
      dashboardUrl: null,
    }
  },
async mounted() {
  const permissionsObj = JSON.parse(sessionStorage.getItem('permissions')) || { permissions: [] };
  const permissions = (permissionsObj.permissions || []).map(p => +p);

  this.accessRecurrence = permissions.includes(5);

  if (!this.accessRecurrence) return;

  const veripagID = sessionStorage.getItem('veripagID');
  if (!veripagID) {
    console.warn('veripagID não encontrado');
    return;
  }

  const METABASE_SITE_URL = metaUrl();
  const METABASE_SECRET_KEY = accessKey();

  const payload = {
    resource: { dashboard: 578 },
    params: { ec: veripagID.toString() },
    exp: Math.round(Date.now() / 1000) + 10 * 60,
  };

  const token = jwt.sign(payload, METABASE_SECRET_KEY);
  this.dashboardUrl = `${METABASE_SITE_URL}embed/dashboard/${token}#bordered=true&titled=true`;
  },
}
</script>
